"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils2 = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var useStyles = function useStyles(props) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _useStylesUtils2.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccProgressStyle = (0, _react.useMemo)(function () {
    var percentage = props.percentage;
    var ccProgress = (0, _css.css)({
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      boxSizing: 'content-box',
      height: pxToRem(6),
      borderTop: '1px solid transparent',
      borderBottom: '1px solid transparent',
      borderRadius: pxToRem(6),
      margin: "".concat(pxToRem(1), " 0"),
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light
    });
    var ccProgressPercentage = (0, _css.css)({
      position: 'absolute',
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
      height: pxToRem(6),
      borderRadius: pxToRem(6),
      left: 0,
      width: "".concat(percentage, "%")
    });
    return {
      ccProgress: ccProgress,
      ccProgressPercentage: ccProgressPercentage
    };
  }, [props, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-Progress': ccProgressStyle.ccProgress,
    'cc-Progress__percentage': ccProgressStyle.ccProgressPercentage
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;